import React, { useEffect, useState } from 'react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState(0);
  // Sample data for notifications
  const notifications = [{
    name: 'María de Chicago',
    price: '9.99 USD',
    time: 'Hace 1 minuto'
  }, {
    name: 'Carlos de Miami',
    price: '9.99 USD',
    time: 'Hace 2 minutos'
  }, {
    name: 'Daniela de Houston',
    price: '9.99 USD',
    time: 'Hace 5 minutos'
  }, {
    name: 'Miguel de Los Angeles',
    price: '9.99 USD',
    time: 'Hace 7 minutos'
  }, {
    name: 'Laura de Nueva York',
    price: '9.99 USD',
    time: 'Hace 10 minutos'
  }, {
    name: 'José de Phoenix',
    price: '9.99 USD',
    time: 'Hace 12 minutos'
  }, {
    name: 'Ana de Dallas',
    price: '9.99 USD',
    time: 'Hace 15 minutos'
  }, {
    name: 'Roberto de San Diego',
    price: '9.99 USD',
    time: 'Hace 20 minutos'
  }];
  useEffect(() => {
    // Show first notification after 3 seconds
    const initialTimer = setTimeout(() => {
      setVisible(true);
      // Auto-hide after 8 seconds
      setTimeout(() => {
        setVisible(false);
      }, 8000);
    }, 3000);
    // Set interval to show a new notification every 45 seconds
    const interval = setInterval(() => {
      // Show notification
      setCurrentNotification(prev => (prev + 1) % notifications.length);
      setVisible(true);
      // Auto-hide after 8 seconds
      setTimeout(() => {
        setVisible(false);
      }, 8000);
    }, 45000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  // Handle closing the notification
  const handleClose = () => {
    setVisible(false);
  };
  if (!visible) return null;
  const notification = notifications[currentNotification];
  return <div className="fixed bottom-4 left-4 z-50 max-w-sm w-full bg-white rounded-lg shadow-lg border border-gray-200 transform transition-transform duration-500 ease-in-out" data-id="element-279">
      <div className="p-4 flex items-start" data-id="element-280">
        <div className="flex-shrink-0 mr-3" data-id="element-281">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2mX5GStNAfV117eqAGBEXD/1-_Guia_de_Crianza_Bilingue_%28Mockup%29.png" alt="Guía de Crianza Bilingüe" className="w-12 h-12 object-cover rounded" data-id="element-282" />
        </div>
        <div className="flex-1" data-id="element-283">
          <h3 className="font-medium text-gray-800" data-id="element-284">
            Guía de Crianza Bilingüe
          </h3>
          <p className="text-xs text-gray-500" data-id="element-285">{notification.time}</p>
          <div className="mt-1 flex items-center" data-id="element-286">
            <span className="inline-flex items-center text-sm text-green-600" data-id="element-287">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" data-id="element-288">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-289"></path>
              </svg>
              Nueva compra completada
            </span>
          </div>
          <p className="text-sm text-gray-600 mt-1" data-id="element-290">
            {notification.name} compró por {notification.price}
          </p>
        </div>
        <button onClick={handleClose} className="flex-shrink-0 text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-291">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-292">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-293"></path>
          </svg>
        </button>
      </div>
    </div>;
}